export default __webpack_public_path__ + "assets/788c15dd656d64a787f1bedcfd79fe7a-letterhead.png";